module.exports = __webpack_public_path__ + "img/face3.16c67435.jpg";